import React, { useState } from 'react';
import './Contact.css';
import bannerImg from '../assets/color-1867371_1920.jpg';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: '',
  });

  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatus('');

    const payload = {
      api_key: 'api-359669F6DC224EFD865964D917E622E6',
      to: ['info@peelsnativeplants.com'],
      sender: 'mail@peelsnativeplants.com',
      reply_to: 'info@peelsnativeplants.com',
      subject: `Contact Form: ${formData.subject || 'No Subject'}`,
      text_body: `
Name: ${formData.name}
Phone: ${formData.phone}
Email: ${formData.email}
Subject: ${formData.subject}
Message: ${formData.message}
      `.trim(),
    };

    try {
      const res = await fetch('https://api.smtp2go.com/v3/email/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.data && data.data.succeeded) {
        setStatus('Message sent successfully!');
        setFormData({ name: '', phone: '', email: '', subject: '', message: '' });
      } else {
        setStatus('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error(error);
      setStatus('Network error. Please try again.');
    }

    setSubmitting(false);
  };

  return (
    <div className="contact-page">
      {/* Banner */}
      <div className="contact-banner" style={{ backgroundImage: `url(${bannerImg})` }}>
        <div className="container">
          <div className="contact-banner-content">
            <h1>Get in touch</h1>
            <p>We're always here to help</p>
          </div>
        </div>
      </div>

      {/* Heading */}
      <div className="contact-heading-text">
        <div className="container">
          <h4 className="section-subtitle">CONTACT US</h4>
          <h2 className="section-title">Our Head Office</h2>
          <p className="section-description">
            View our contact details below or submit the form to reach us directly.
          </p>
        </div>
      </div>

      {/* Info */}
      <div className="contact-info">
        <div className="container info-grid">
          <div className="info-box">
            <FaPhoneAlt className="info-icon" />
            <h3>Phone</h3>
            <p>604-217-1351</p>
          </div>
          <div className="info-box">
            <FaMapMarkerAlt className="info-icon" />
            <h3>Address</h3>
            <p>Nursery Address:<br />22064 64 Ave, Langley, BC, V2Y 2N8</p>
          </div>
          <div className="info-box">
            <FaEnvelope className="info-icon" />
            <h3>Email</h3>
            <p>info@peelsnativeplants.com</p>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <div className="contact-form-section">
        <div className="container">
          <h2 className="form-heading">Send us a message</h2>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <input
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="phone"
                placeholder="Enter phone number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-row">
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="subject"
                placeholder="Enter your subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </div>
            <textarea
              name="message"
              placeholder="Enter your detailed message here"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <button type="submit" className="quote-button" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Contact Now'}
            </button>

            {status && (
              <p className={`form-status ${status.includes('success') ? 'success' : 'error'}`}>
                {status}
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
